import { render, staticRenderFns } from "./ModalImageProfile.vue?vue&type=template&id=ca3e0d4c"
import script from "./ModalImageProfile.vue?vue&type=script&lang=ts"
export * from "./ModalImageProfile.vue?vue&type=script&lang=ts"
import style0 from "./ModalImageProfile.vue?vue&type=style&index=0&id=ca3e0d4c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports